<template>
  <div :class="['inbox_item', {'is-active': isActive}]">
    <div class="inbox_item--top" @click="updateActiveItem">
      <!--New Lead Heading-->
      <h3
        v-if="isNewLead"
        class="inbox_item--heading"
      >
        <sensitive-data-wrapper>
          <span>
            New Lead
            <span v-if="item.property.line_1" class="inbox_item--heading--side_label">{{ item.property.line_1 }}</span>
          </span>
        </sensitive-data-wrapper>
        <span class="inbox_item--heading--icons"><record-icons :record="item" tooltip-position="is-left"></record-icons></span>
      </h3>

      <!--Inbound Comm Heading-->
      <template v-if="isInboundComm">
        <!--Contact-->
        <sensitive-data-wrapper>
          <h3 class="inbox_item--heading">{{ item.full_name }}</h3>
        </sensitive-data-wrapper>

        <!--Lead(s)-->
        <h3 v-if="item.primaryRecord" class="inbox_item--heading">
          <sensitive-data-wrapper>
            {{ item.primaryRecord.property.line_1 ? item.primaryRecord.property.line_1 : "Unknown Address" }}
          </sensitive-data-wrapper>
          <span class="inbox_item--heading--icons"><record-icons :record="item.primaryRecord"
                                                                 tooltip-position="is-left"></record-icons></span>
        </h3>
        <h3 v-else class="inbox_item--heading no_primary">No Primary Lead</h3>
      </template>

      <!--New Lead or Contact Source-->
      <inbox-item-source
        v-if="isNewLead"
        :item="item"
        :is-new-lead="isNewLead"
        :is-inbound-comm="isInboundComm"
      ></inbox-item-source>

      <!--Inbound Comm Source(s)-->
      <template v-if="isInboundComm">
        <!--      v-for="item in item.communicationLogs"-->
        <inbox-item-source
          v-for="item in communicationLogs"
          :key="item.id"
          :item="item"
          :is-new-lead="isNewLead"
          :is-inbound-comm="isInboundComm"
        ></inbox-item-source>
      </template>
    </div>

    <!--Viewing and Done-->
    <div
      v-if="isActive"
      class="inbox_item--bottom flex flex-vertical-center mt-50"
    >
      <div class="inbox_item--viewing">
        <p
          v-for="user in viewedBy"
          :key="user.id"
        >{{ user.full_name }} Viewing</p>
      </div>

      <button-default
        v-if="isActive"
        @click="markDone"
        class="ml-auto"
        is-short
      >Done
      </button-default>
    </div>
  </div>
</template>

<script>
import InboxItemSource from "./InboxItemSource";
import {MODELS} from "../../../services/models";
import {ENUMS} from "../../../services/enums";
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "InboxItemDesktop",
  components: {SensitiveDataWrapper, InboxItemSource},
  props: {
    data: {},
    itemIndex: Number,
    isActive: {
      type: Boolean,
      default: false
    },
    viewedBy: {
      type: Array,
      required: true
    }
  },
  computed: {
    item() {
      return {
        itemIndex: this.itemIndex,
        ...this.data
      };
    },
    isNewLead() {
      return this.item.inbox_type === ENUMS.InboxTypeEnum.NewLead.value;
    },
    isInboundComm() {
      return this.item.inbox_type === ENUMS.InboxTypeEnum.InboundComm.value;
    },
    inboundComms() {
      return this.$store.getters["inbox/inboundComms"];
    },
    communicationLogs() {
      if (this.isInboundComm) {
        return this.inboundComms.filter(comm => this.item.id === comm.contact_id);
      }

      return [];
    },
  },
  methods: {
    markDone() {
      const addressedBy = {
        id: this.$store.getters.authUser.id,
        class_name: MODELS.User.class_name,
      };

      // Need to emit this to parent so that it updates activeItemIndex
      this.$emit("markedDone", this.item);

      if (this.isNewLead) {
        this.$api.records.setAddressed(this.item.id, {addressedBy: addressedBy}).then(() => {
          this.$buefy.toast.open({message: "New Lead has been marked done", type: "is-success"});
        });
      }

      if (this.isInboundComm) {
        const commIds = this.item.communicationLogs.map(c => c.id);

        this.$api.communicationLogs.setAllAddressed({ids: commIds, addressedBy: addressedBy}).then(() => {
          this.$buefy.toast.open({message: "Inbound comm has been marked done", type: "is-success"});
        });
      }
    },
    updateActiveItem() {
      this.$emit("updateActive", this.item);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.inbox_item {
  border-left: 4px solid transparent;
  border-bottom: 1px solid $border;

  &:hover {
    background-color: $grey-50;
    border-left-color: $grey-100;
  }

  .inbox_item--top {
    padding: 8px;
    cursor: pointer;
  }

  .inbox_item--bottom {
    padding: 0 8px 8px;
  }

  &.is-active {
    border-left-color: $primary;
    background-color: $white;
  }

  &--heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;

    &--side_label {
      display: block;
      margin-top: 3px;
      font-size: 0.875rem;
      color: $text-muted;
    }

    &--icons {
      margin-left: 6px;
      color: $text-light;
    }

    &.no_primary {
      color: $text-muted;
      font-style: italic;
    }
  }

  &--viewing {
    color: $primary;
    font-size: 0.75rem;
    font-weight: bold;
  }
}
</style>
